export const localeOrder = ['en', 'zh-CN', 'zh-TW']

export const siteConfig = {
  siteUrl: 'https://chicross.com',
  brandNameEn: 'CHICROSS STUDIO',
  brandNameZh: '構域矩陣工作室',
  legalName: '構域矩陣工作室 CHICROSS STUDIO',
  registrationNumber: '41595563-000-01-26-8',
  contactEmail: 'max@chicross.com',
  defaultLang: 'en',
}

export const themeTokens = {
  colors: {
    violet: '#8b5cf6',
    cyan: '#22d3ee',
    gold: '#f5c451',
    magenta: '#ec4899',
    indigo: '#6366f1',
    void: '#05060a',
    panel: '#0b0e16',
    line: '#1b2130',
    inkHi: '#f4f2ec',
    inkMid: '#9aa3b2',
    inkLow: '#5b6577',
  },
}

export const effectSpecs = [
  {
    id: 'FX-01',
    name: 'Aurora Field',
    reducedMotionFallback: 'Freeze to one static aurora gradient frame.',
  },
  {
    id: 'FX-02',
    name: 'Single-Layer Text-Mask Aurora',
    reducedMotionFallback: 'Stop particle drift and gradient travel while keeping the masked wordmark visible.',
  },
  {
    id: 'FX-03',
    name: 'Film Grain, Vignette, Letterbox',
    reducedMotionFallback: 'Keep vignette and letterbox; freeze grain.',
  },
  {
    id: 'FX-04',
    name: 'Kinetic Marquee',
    reducedMotionFallback: 'Stop marquee movement with all text readable.',
  },
  {
    id: 'FX-05',
    name: 'Magnetic Cursor and Parallax Spotlight',
    reducedMotionFallback: 'Disable cursor following and magnetic offsets.',
  },
  {
    id: 'FX-06',
    name: 'Scroll-Scrubbed Camera',
    reducedMotionFallback: 'Reveal content directly without pinned scrub animation.',
  },
  {
    id: 'FX-07',
    name: 'Live Status Ticker',
    reducedMotionFallback: 'Keep the latest operating status visible without numeric jumping.',
  },
]

export const routeDefinitions = [
  { key: 'home', slug: '' },
  { key: 'services', slug: 'services' },
  { key: 'work', slug: 'work' },
  { key: 'research', slug: 'research' },
  { key: 'process', slug: 'process' },
  { key: 'about', slug: 'about' },
  { key: 'faq', slug: 'faq' },
  { key: 'contact', slug: 'contact' },
]

const serviceDomains = {
  en: [
    {
      code: 'FRONT',
      title: 'Front deployment engineering',
      outcome: 'Production front ends, product surfaces, and launch paths that are deployable, observable, and reversible.',
      deliverables: ['React/Vite product surface', 'Cloudflare deployment chain', 'Release runbook'],
    },
    {
      code: 'SAAS',
      title: 'SaaS product systems',
      outcome: 'Repeated internal operations become tenant-aware tools, admin consoles, customer dashboards, and iteration-ready products.',
      deliverables: ['Product architecture', 'Tenant and data model', 'Admin and ops console'],
    },
    {
      code: 'CTRL',
      title: 'Real-world industrial control',
      outcome: 'industrial control interfaces that connect machines, sensors, edge devices, and operators before automation takes action.',
      deliverables: ['Edge/on-prem pattern', 'Operator dashboard', 'Alarm and audit trail'],
    },
    {
      code: 'AI',
      title: 'AI transformation for traditional industries',
      outcome: 'AI enters existing teams through document intake, judgement support, quality checks, and searchable operational knowledge.',
      deliverables: ['AI evaluation harness', 'Human review route', 'Knowledge workflow'],
    },
    {
      code: 'AUTO',
      title: 'Low-supervision business workflows',
      outcome: 'Unattended or lightly supervised processes run with retries, exception routing, escalation, and proof of completion.',
      deliverables: ['Workflow engine', 'Exception queue', 'Observability and audit logs'],
    },
  ],
  'zh-CN': [
    {
      code: 'FRONT',
      title: '前端与部署工程',
      outcome: '把官网、产品前台、运营后台一起交付到可发布、可回滚、可观测的生产环境。',
      deliverables: ['React/Vite 产品界面', 'Cloudflare 部署链路', '发布与回滚手册'],
    },
    {
      code: 'SAAS',
      title: 'SaaS 产品系统',
      outcome: '把重复的内部运营能力整理成可订阅、可权限分层、可持续迭代的产品系统。',
      deliverables: ['产品架构', '租户/数据模型', '管理与运营控制台'],
    },
    {
      code: 'CTRL',
      title: '真实世界工业控制',
      outcome: '连接机器、传感器、边缘设备与操作员界面，在自动动作前先建立可见、可审计、可回退的控制层。',
      deliverables: ['边缘/本地部署模式', '操作员看板', '告警与审计轨迹'],
    },
    {
      code: 'AI',
      title: '传统行业 AI 化改造',
      outcome: '把 AI 放进传统团队已有流程：单证处理、判断辅助、质量复核、知识检索与交接文档。',
      deliverables: ['AI 评测基准', '人审分流', '知识流程改造'],
    },
    {
      code: 'AUTO',
      title: '无人/少人工监管流程',
      outcome: '为高重复业务构建可无人值守或极少人工监管的流程，异常才进入人工队列。',
      deliverables: ['流程引擎', '异常队列', '可观测与审计日志'],
    },
  ],
  'zh-TW': [
    {
      code: 'FRONT',
      title: '前端與部署工程',
      outcome: '把官網、產品前台、營運後台一起交付到可發布、可回滾、可觀測的生產環境。',
      deliverables: ['React/Vite 產品介面', 'Cloudflare 部署鏈路', '發布與回滾手冊'],
    },
    {
      code: 'SAAS',
      title: 'SaaS 產品系統',
      outcome: '把重複的內部營運能力整理成可訂閱、可權限分層、可持續迭代的產品系統。',
      deliverables: ['產品架構', '租戶/數據模型', '管理與營運控制台'],
    },
    {
      code: 'CTRL',
      title: '真實世界工業控制',
      outcome: '連接機器、感測器、邊緣設備與操作員介面，在自動動作前先建立可見、可審計、可回退的控制層。',
      deliverables: ['邊緣/本地部署模式', '操作員看板', '告警與審計軌跡'],
    },
    {
      code: 'AI',
      title: '傳統行業 AI 化改造',
      outcome: '把 AI 放進傳統團隊已有流程：單證處理、判斷輔助、品質覆核、知識檢索與交接文件。',
      deliverables: ['AI 評測基準', '人審分流', '知識流程改造'],
    },
    {
      code: 'AUTO',
      title: '無人/少人工監管流程',
      outcome: '為高重複業務構建可無人值守或極少人工監管的流程，異常才進入人工隊列。',
      deliverables: ['流程引擎', '異常隊列', '可觀測與審計日誌'],
    },
  ],
}

const processSteps = {
  en: [
    ['Brief', 'Name the workflow, users, constraints, and definition of done.'],
    ['Scope & Plan', 'Turn unknowns into boundaries, milestones, and acceptance checks.'],
    ['Build', 'Ship the smallest reliable system that can survive real operation.'],
    ['Validate', 'Measure behavior, review exceptions, and tune handoff evidence.'],
    ['Handoff & Iterate', 'Transfer runbooks, ownership, and a clear next-change path.'],
  ],
  'zh-CN': [
    ['问题定义', '明确流程、使用者、约束与完成标准。'],
    ['范围与方案', '把未知项变成边界、里程碑与验收检查。'],
    ['迭代交付', '交付能进入真实运营的最小可靠系统。'],
    ['验证评估', '测量行为、复盘异常，并整理交接证据。'],
    ['交接迭代', '移交手册、负责人和下一轮变更路径。'],
  ],
  'zh-TW': [
    ['問題定義', '明確流程、使用者、約束與完成標準。'],
    ['範圍與方案', '把未知項變成邊界、里程碑與驗收檢查。'],
    ['迭代交付', '交付能進入真實營運的最小可靠系統。'],
    ['驗證評估', '測量行為、復盤異常，並整理交接證據。'],
    ['交接迭代', '移交手冊、負責人和下一輪變更路徑。'],
  ],
}

const proofRecords = {
  en: [
    ['ARCH-01', 'Architecture notes', 'System boundaries, data flows, and operational assumptions before implementation hardens.'],
    ['RUN-04', 'Runbooks and monitoring', 'Recovery paths, logging expectations, and checkpoints for the people running the system.'],
    ['HAND-12', 'Knowledge transfer', 'Handoff sessions, change notes, and maintenance guidance after launch.'],
  ],
  'zh-CN': [
    ['ARCH-01', '架构注记', '在实现固化前记录系统边界、数据流与运营假设。'],
    ['RUN-04', '运行手册与监控', '为真正运行系统的人保留恢复路径、日志预期与可见检查点。'],
    ['HAND-12', '知识交接', '上线后的交接会议、变更记录与维护指引。'],
  ],
  'zh-TW': [
    ['ARCH-01', '架構註記', '在實作固化前記錄系統邊界、數據流與營運假設。'],
    ['RUN-04', '運行手冊與監控', '為真正運行系統的人保留恢復路徑、日誌預期與可見檢查點。'],
    ['HAND-12', '知識交接', '上線後的交接會議、變更記錄與維護指引。'],
  ],
}

function makePages(locale, labels) {
  const domains = serviceDomains[locale]
  const steps = processSteps[locale]
  const records = proofRecords[locale]

  return {
    home: {
      title: labels.brand,
      description: labels.description,
    },
    services: {
      title: labels.nav.services,
      description: labels.servicesIntro,
      sections: domains.map((domain) => ({
        title: `${domain.code} · ${domain.title}`,
        body: domain.outcome,
        items: domain.deliverables,
      })),
    },
    work: {
      title: labels.nav.work,
      description: labels.workIntro,
      sections: records.map(([code, title, body]) => ({
        title: `${code} · ${title}`,
        body,
        items: labels.workItems,
      })),
    },
    research: {
      title: labels.nav.research,
      description: labels.researchIntro,
      sections: labels.researchNotes.map((note) => ({
        title: note[0],
        body: note[1],
        items: note.slice(2),
      })),
    },
    process: {
      title: labels.nav.process,
      description: labels.processIntro,
      sections: steps.map(([title, body], index) => ({
        title: `${String(index + 1).padStart(2, '0')} · ${title}`,
        body,
        items: labels.processItems,
      })),
    },
    about: {
      title: labels.nav.about,
      description: labels.aboutIntro,
      sections: [
        {
          title: labels.legalTitle,
          body: `${siteConfig.legalName}, ${labels.registeredLine}`,
          items: [`Reg. ${siteConfig.registrationNumber}`, siteConfig.contactEmail],
        },
        {
          title: labels.workingPrinciplesTitle,
          body: labels.workingPrinciplesBody,
          items: labels.principles,
        },
      ],
    },
    faq: {
      title: labels.nav.faq,
      description: labels.faqIntro,
      sections: labels.faqItems.map((item) => ({
        title: item[0],
        body: item[1],
        items: [],
      })),
    },
    contact: {
      title: labels.nav.contact,
      description: labels.contactIntro,
      sections: [
        {
          title: labels.contactTitle,
          body: labels.contactBody,
          items: [siteConfig.contactEmail, labels.contactBrief],
        },
      ],
    },
    privacy: {
      title: labels.footer.privacy,
      description: labels.privacyIntro,
      sections: labels.privacyItems.map((item) => ({ title: item[0], body: item[1], items: [] })),
    },
    terms: {
      title: labels.footer.terms,
      description: labels.termsIntro,
      sections: labels.termsItems.map((item) => ({ title: item[0], body: item[1], items: [] })),
    },
  }
}

const localized = {
  en: {
    label: 'English',
    localeSwitchLabel: 'EN',
    htmlLang: 'en',
    ogLocale: 'en_US',
    brand: 'CHICROSS STUDIO',
    chineseBrand: '構域矩陣工作室',
    tagline: 'Deployable fronts. SaaS engines. Real-world automation.',
    description: 'IT and digital services for deployment engineering, SaaS systems, industrial interfaces, AI transformation, and low-supervision operations.',
    manifesto: 'We do not ship demos. We deliver systems that keep running.',
    manifestoAside: 'Engineering-first · Research-driven · Iterative delivery · Explicit boundaries',
    nav: {
      home: 'Home',
      services: 'Services',
      work: 'Work',
      research: 'Research',
      process: 'Process',
      about: 'About',
      faq: 'FAQ',
      contact: 'Contact',
    },
    footer: { privacy: 'Privacy', terms: 'Terms' },
    primaryCta: 'Start a build',
    secondaryCta: 'View services',
    servicesIntro: 'Five directions, one operating standard: production systems that can be deployed, observed, handed off, and improved.',
    workIntro: 'Evidence is shown through deliverables: notes, runbooks, review gates, and transfer records.',
    researchIntro: 'Lab notes on reliability, document understanding, and evaluation before experiments become daily operations.',
    processIntro: 'A short delivery pipeline keeps scope visible from brief through handoff.',
    aboutIntro: 'A Hong Kong-registered IT studio for deployment engineering, SaaS systems, AI transformation, and automation work.',
    faqIntro: 'Practical answers about scope, handoff, content, and operating constraints.',
    contactIntro: 'Bring the workflow, constraint, deadline, and desired operating result.',
    contactTitle: 'Open a work order',
    contactBody: 'A useful first brief names the workflow, the people who run it, the tools already in place, and what needs to be true after launch.',
    contactBrief: 'Include context, systems, access constraints, timeline, and success criteria.',
    legalTitle: 'Registration',
    registeredLine: 'registered in Hong Kong.',
    workingPrinciplesTitle: 'Working principles',
    workingPrinciplesBody: 'The studio favors explicit scope, measurable handoff, and systems that can be owned after launch.',
    principles: ['Engineering-first', 'Research-driven', 'Iterative delivery', 'Explicit boundaries'],
    workItems: ['Architecture notes', 'Deployment configuration', 'Runbook', 'Review gate'],
    processItems: ['Scope boundary', 'Acceptance check', 'Owner map'],
    researchNotes: [
      ['Workflow durability', 'Patterns for long-running automations, retries, and human review gates.', 'Retries', 'Audit trails'],
      ['Document understanding', 'Extraction, validation, confidence scoring, and review routing.', 'Confidence', 'QA routes'],
      ['Evaluation frameworks', 'Accuracy, latency, traceability, and operational acceptance criteria.', 'Score sheets', 'Decision logs'],
    ],
    faqItems: [
      ['Do you provide ongoing content production?', 'Engineering and delivery are core. Ongoing content and brand production are only included when explicitly scoped.'],
      ['Can you integrate existing SaaS tools?', 'Yes, when API access, rate limits, permissions, and data ownership can be defined early.'],
      ['What does handoff include?', 'Runbooks, access notes, maintenance guidance, and the constraints that future changes should respect.'],
    ],
    privacyIntro: 'Last updated: January 2026. The site keeps data handling minimal.',
    privacyItems: [
      ['Data collection', 'Contact messages and basic operational logs may be processed to respond and maintain the site.'],
      ['No tracking cookies', 'The site does not require advertising cookies. Basic analytics may be used only to understand site reliability.'],
      ['Contact', `Questions can be sent to ${siteConfig.contactEmail}.`],
    ],
    termsIntro: 'Last updated: January 2026. These terms describe site use and project boundaries.',
    termsItems: [
      ['Use of site', 'Content is provided for general information about the studio and its services.'],
      ['Project scope', 'Commercial work is governed by written scope, payment, delivery, and handoff terms.'],
      ['Disputes', 'Disputes should first be handled through good-faith negotiation.'],
    ],
  },
  'zh-CN': {
    label: '简体中文',
    localeSwitchLabel: '简体',
    htmlLang: 'zh-CN',
    ogLocale: 'zh_CN',
    brand: '構域矩陣工作室',
    chineseBrand: 'CHICROSS STUDIO',
    tagline: '可部署的前端，可运营的 SaaS，可落地的自动化。',
    description: '企业级 IT 与数字化服务，覆盖部署工程、SaaS 系统、工业控制界面、AI 化改造与少人工监管业务流程。',
    manifesto: '我们不做演示，我们交付会运行的系统。',
    manifestoAside: '工程优先 · 研究驱动 · 迭代交付 · 边界清晰',
    nav: {
      home: '首页',
      services: '服务',
      work: '案例',
      research: '研究',
      process: '流程',
      about: '关于',
      faq: '常见问题',
      contact: '联系',
    },
    footer: { privacy: '隐私政策', terms: '条款' },
    primaryCta: '开始构建',
    secondaryCta: '查看服务',
    servicesIntro: '五个业务方向，一套交付标准：可部署、可观测、可交接、可持续改进的生产系统。',
    workIntro: '用交付物呈现证据：架构注记、运行手册、评审门与知识交接。',
    researchIntro: '在实验能力进入日常运营前，研究可靠性、文档理解与评估框架。',
    processIntro: '从问题定义到交接迭代，用短管线保持范围可见。',
    aboutIntro: '面向部署工程、SaaS 系统、AI 化改造与自动化的香港登记 IT 工作室。',
    faqIntro: '关于范围、交接、内容与运营约束的实际说明。',
    contactIntro: '带上流程、约束、截止时间与期望的运营结果。',
    contactTitle: '开启工作单',
    contactBody: '一个有效需求会说明流程、使用者、既有工具，以及上线后必须成立的结果。',
    contactBrief: '请包含背景、系统、访问约束、时间线与成功标准。',
    legalTitle: '登记信息',
    registeredLine: '香港登记商业体。',
    workingPrinciplesTitle: '工作原则',
    workingPrinciplesBody: '工作室偏好清晰范围、可测量交接，以及上线后能被继续拥有的系统。',
    principles: ['工程优先', '研究驱动', '迭代交付', '边界清晰'],
    workItems: ['架构注记', '部署配置', '运行手册', '评审门'],
    processItems: ['范围边界', '验收检查', '负责人映射'],
    researchNotes: [
      ['工作流可靠性', '长运行自动化、重试策略与人审节点的模式。', '重试', '审计追踪'],
      ['文档理解', '抽取、校验、置信度评分与复核分流。', '置信度', '质控路径'],
      ['评估框架', '准确率、延迟、可追溯性与运营验收标准。', '评分表', '决策记录'],
    ],
    faqItems: [
      ['是否提供长期内容生产？', '核心范围是工程与交付。长期内容与品牌生产仅在明确约定时纳入。'],
      ['能否接入现有 SaaS 工具？', '可以，前提是尽早明确 API 权限、速率限制、权限模型与数据归属。'],
      ['交接包含什么？', '运行手册、访问说明、维护指引，以及未来变更需要尊重的约束。'],
    ],
    privacyIntro: '最后更新：2026 年 1 月。本网站尽量减少数据处理。',
    privacyItems: [
      ['数据收集', '联系消息与基础运行日志可能用于回复咨询与维护网站。'],
      ['无广告 Cookie', '网站不需要广告 Cookie。基础分析只用于理解网站可靠性。'],
      ['联系', `问题可发送至 ${siteConfig.contactEmail}。`],
    ],
    termsIntro: '最后更新：2026 年 1 月。本条款说明网站使用与项目边界。',
    termsItems: [
      ['网站使用', '内容仅用于介绍工作室及其服务。'],
      ['项目范围', '商业项目以书面范围、付款、交付与交接条款为准。'],
      ['争议', '争议应先通过善意协商处理。'],
    ],
  },
  'zh-TW': {
    label: '繁體中文',
    localeSwitchLabel: '繁体',
    htmlLang: 'zh-TW',
    ogLocale: 'zh_TW',
    brand: '構域矩陣工作室',
    chineseBrand: 'CHICROSS STUDIO',
    tagline: '可部署的前端，可營運的 SaaS，可落地的自動化。',
    description: '企業級 IT 與數位化服務，覆蓋部署工程、SaaS 系統、工業控制介面、AI 化改造與少人工監管業務流程。',
    manifesto: '我們不做演示，我們交付會運行的系統。',
    manifestoAside: '工程優先 · 研究驅動 · 迭代交付 · 邊界清晰',
    nav: {
      home: '首頁',
      services: '服務',
      work: '案例',
      research: '研究',
      process: '流程',
      about: '關於',
      faq: '常見問題',
      contact: '聯繫',
    },
    footer: { privacy: '隱私政策', terms: '條款' },
    primaryCta: '開始構建',
    secondaryCta: '查看服務',
    servicesIntro: '五個業務方向，一套交付標準：可部署、可觀測、可交接、可持續改進的生產系統。',
    workIntro: '用交付物呈現證據：架構註記、運行手冊、評審門與知識交接。',
    researchIntro: '在實驗能力進入日常營運前，研究可靠性、文檔理解與評估框架。',
    processIntro: '從問題定義到交接迭代，用短管線保持範圍可見。',
    aboutIntro: '面向部署工程、SaaS 系統、AI 化改造與自動化的香港登記 IT 工作室。',
    faqIntro: '關於範圍、交接、內容與營運約束的實際說明。',
    contactIntro: '帶上流程、約束、截止時間與期望的營運結果。',
    contactTitle: '開啟工作單',
    contactBody: '一個有效需求會說明流程、使用者、既有工具，以及上線後必須成立的結果。',
    contactBrief: '請包含背景、系統、訪問約束、時間線與成功標準。',
    legalTitle: '登記資訊',
    registeredLine: '香港登記商業體。',
    workingPrinciplesTitle: '工作原則',
    workingPrinciplesBody: '工作室偏好清晰範圍、可測量交接，以及上線後能被繼續擁有的系統。',
    principles: ['工程優先', '研究驅動', '迭代交付', '邊界清晰'],
    workItems: ['架構註記', '部署配置', '運行手冊', '評審門'],
    processItems: ['範圍邊界', '驗收檢查', '負責人映射'],
    researchNotes: [
      ['工作流可靠性', '長運行自動化、重試策略與人審節點的模式。', '重試', '審計追蹤'],
      ['文檔理解', '抽取、校驗、置信度評分與覆核分流。', '置信度', '質控路徑'],
      ['評估框架', '準確率、延遲、可追溯性與營運驗收標準。', '評分表', '決策記錄'],
    ],
    faqItems: [
      ['是否提供長期內容生產？', '核心範圍是工程與交付。長期內容與品牌生產僅在明確約定時納入。'],
      ['能否接入現有 SaaS 工具？', '可以，前提是盡早明確 API 權限、速率限制、權限模型與數據歸屬。'],
      ['交接包含什麼？', '運行手冊、訪問說明、維護指引，以及未來變更需要尊重的約束。'],
    ],
    privacyIntro: '最後更新：2026 年 1 月。本網站盡量減少數據處理。',
    privacyItems: [
      ['數據收集', '聯繫消息與基礎運行日誌可能用於回覆諮詢與維護網站。'],
      ['無廣告 Cookie', '網站不需要廣告 Cookie。基礎分析只用於理解網站可靠性。'],
      ['聯繫', `問題可發送至 ${siteConfig.contactEmail}。`],
    ],
    termsIntro: '最後更新：2026 年 1 月。本條款說明網站使用與項目邊界。',
    termsItems: [
      ['網站使用', '內容僅用於介紹工作室及其服務。'],
      ['項目範圍', '商業項目以書面範圍、付款、交付與交接條款為準。'],
      ['爭議', '爭議應先通過善意協商處理。'],
    ],
  },
}

export const siteContent = Object.fromEntries(
  localeOrder.map((locale) => {
    const labels = localized[locale]
    return [
      locale,
      {
        ...labels,
        services: serviceDomains[locale],
        processSteps: processSteps[locale],
        proofRecords: proofRecords[locale],
        nav: routeDefinitions.map((route) => ({
          ...route,
          label: labels.nav[route.key],
        })),
        pages: makePages(locale, labels),
      },
    ]
  }),
)
